import {
  CASELIST,
  CLAIMBYDEBTOR,
  CLAIM_BASIC_SEARCH,
  ClaimListInCreditor,
} from "@/services/constant/apiPath";
import { ccwpApi } from "@/services";
import { CASE_SUMMARY } from "./type";
import { CaseSetupType } from "@/pages/CaseDetail/CaseSetup/CaseSetupType";

const commonParams = {
  Type: "quick search",
  OrderBy: "desc",
  PageNo: 1,
  PageSize: 10,
};

// Define a service using a base URL and expected endpoints
export const caseListApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    searchCaseListData: builder.query<any, any>({
      query: (arg) =>( {url:CASELIST ,
      method: "GET",
      params: {...arg}})
    }),
    createCase: builder.mutation<any, any>({
      query: (caseData: CaseSetupType) => ({
        url: `Case/CreateCase`,
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: caseData,
      }),
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useSearchCaseListDataQuery,
  useCreateCaseMutation,
} = caseListApi;


// Define a service using a base URL and expected endpoints
export const caseClaimListApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getCaseClaimListData: builder.query<any, any>({
      query: (args) =>({url:"Claim/GetListClaims",method:"GET",params:{...args}}),
    }),
    getClaimListByCaseQuickSearch: builder.query<
      any,
      { CaseId?: string; SearchText?: string }
    >({
      query: (args) => {
        return {
          url: "Claim/GetListClaims",
          params: {
           ...args
          },
        };
      },
    }),

    getClaimBasicSearch: builder.query({
      query: ({
        CaseId,
        ClaimReference,
        CreditorName,
        DebtorName,
        ClaimUpdatedDateStart,
        ClaimUpdatedDateEnd,
        ClaimStageId,
        ClaimStatusId,
        IsFromPortal,
        CategoryId,
        NatureOfClaim,
        IsOverDue,
        TaskStatus,
        PageNumber,
        PageSize,
        SearchText,
        SortColumn,
        SortOrder,
        IsResolved
      }) => ({
        url: CLAIM_BASIC_SEARCH,
        method: "GET",
        params: {
          CaseId,
          ClaimReference,
          CreditorName,
          DebtorName,
          ClaimUpdatedDateStart,
          ClaimUpdatedDateEnd,
          ClaimStageId,
          ClaimStatusId,
          IsFromPortal,
          CategoryId,
          NatureOfClaim,
          IsOverDue,
          TaskStatus, 
          PageNumber,
          PageSize,
          SearchText,
          SortColumn,
          SortOrder ,
          IsResolved      },
      }),
    }),
    getClaimBasicSearchCreditorTab: builder.query({
      query: ({
        CaseId,
        ClaimReference,
        CreditorName,
        DebtorName,
        ClaimUpdatedDateStart,
        ClaimUpdatedDateEnd,
        ClaimStageId,
        ClaimStatusId,
        IsFromPortal,
        CategoryId,
        NatureOfClaim,
        IsOverDue,
        TaskStatus,
        PageNumber,
        PageSize,
        SearchText,
        SortColumn,
        SortOrder,
        CreditorReference,
      }) => ({
        url: CLAIM_BASIC_SEARCH,
        method: "GET",
        params: {
          CaseId,
          ClaimReference,
          CreditorName,
          DebtorName,
          ClaimUpdatedDateStart,
          ClaimUpdatedDateEnd,
          ClaimStageId,
          ClaimStatusId,
          IsFromPortal,
          CategoryId,
          NatureOfClaim,
          IsOverDue,
          TaskStatus, 
          PageNumber,
          PageSize,
          SearchText,
          SortColumn,
          SortOrder,
          CreditorReference
        },
      }),
    }),


  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetCaseClaimListDataQuery,
  useLazyGetClaimListByCaseQuickSearchQuery,
  useLazyGetClaimBasicSearchQuery,
  useLazyGetClaimBasicSearchCreditorTabQuery
} = caseClaimListApi;

// Define a service using a base URL and expected endpoints
export const creditorClaimListApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getCreditorClaimListApiData: builder.query<any, any>({
      query: (arg) =>{
        return {url:ClaimListInCreditor,method:"GET",params:{...arg}}

      },
    }),
    getCreditorClaimListByCaseQuickSearch: builder.query<
    any,
    { CaseId?: string; CreditorId?: string, SearchText?: string }
  >({
    query: ({ CaseId, CreditorId, SearchText }) => {
      return {
        url: CLAIMBYDEBTOR + CaseId + "&creditorId=" + CreditorId,
        params: {
          ...commonParams,
          SearchText,
        },
      };
    },
      transformResponse: (response: { results: any[] }) => response.results,
  }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetCreditorClaimListApiDataQuery, useLazyGetCreditorClaimListByCaseQuickSearchQuery } = creditorClaimListApi;

// Define a service using a base URL and expected endpoints
export const debtorClaimListApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getDebtorClaimListApiData: builder.query<any, any>({
      query: (arg) => ({url:"Claim/GetListClaims",method:"GET",params:{...arg}}),
    }),
    getDebtorClaimListByCaseQuickSearch: builder.query<
      any,
      { CaseId?: string; DebtorId?: string, SearchText?: string }
    >({
      query: ({ CaseId, DebtorId, SearchText }) => {
        return {
          url: CLAIMBYDEBTOR + CaseId + "&debtorId=" + DebtorId,
          params: {
            ...commonParams,
            SearchText,
          },
        };
      },
      transformResponse: (response: { results: any[] }) => response.results,
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetDebtorClaimListApiDataQuery, useLazyGetDebtorClaimListByCaseQuickSearchQuery } = debtorClaimListApi;

export const caseSummaryFormApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    updateCase: builder.mutation<CASE_SUMMARY, Partial<CASE_SUMMARY>>({
      query: (newPost) => ({
        url: `Case/UpdateCase`,
        method: "PUT",
        body: newPost,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useUpdateCaseMutation } = caseSummaryFormApi;
